import { useCallback } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { useAddErrorData } from '../../../error-boundary-context/context';

export const useErrorInfo = () => {
    const addErrorData = useAddErrorData();

    const instance = usePlayerInstance();

    const setVsid = useCallback(() => {
        if (instance) {
            addErrorData({ vsid: instance.vsid });
        }
    }, [addErrorData, instance]);

    useInstanceEffect(
        (instance) => {
            instance.onReady(setVsid);
        },
        [setVsid]
    );
};
